"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetTotalLock = exports.TotalLockFields = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.TotalLockFields = (0, graphql_tag_1.default) `
  fragment TotalLockFields on TotalLock {
    id
    totalStake
    totalDelegation
  }
`;
exports.GetTotalLock = (0, graphql_tag_1.default) `
  query GetTotalLock {
    totalLocks {
      totalCount
      nodes {
        ...TotalLockFields
      }
    }
  }
  ${exports.TotalLockFields}
`;
//# sourceMappingURL=totalLock.generated.js.map